<script>
import MethodButtonBase from './MethodButtonBase';
import IdinIcon from '../../assets/svg/idin-logo.svg';
export default {
  name: 'IdinButton',
  components: {
    MethodButtonBase,
    IdinIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IdinIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('iDIN') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 34px;
  height: auto;
  margin-right: 8px;
}
</style>
